import { regex } from './regex'
import { checkIdCard } from './idcard'

// supportSensitive 是否支持脱敏校验
const validInput = (value, callback, reg, supportSensitive = false) => {
  if (value) {
    if (supportSensitive && `${value}`.includes('*')) {
      callback()
    } else if (!reg.test(value)) {
      return callback(new Error(''))
    }
  }
  callback()
}
const validInputSymbols = (value, callback, reg) => {
  if (value && reg.test(value)) {
    return callback(new Error(''))
  }
  callback()
}

export const formValid = {
  validNameCN: (rule, value, callback) => {
    validInput(value, callback, regex.realName)
  },
  validSceneName: (rule, value, callback) => {
    validInput(value, callback, regex.sceneName)
  },
  validInputCN: (rule, value, callback) => {
    validInput(value, callback, regex.inputCN)
  },
  validPoint: (rule, value, callback) => {
    validInput(value, callback, regex.floatNumber)
  },
  validPoint2: (rule, value, callback) => {
    validInput(value, callback, regex.floatNumber2)
  },
  validPoint3: (rule, value, callback) => {
    validInput(value, callback, regex.number0_100)
  },
  validPoint4: (rule, value, callback) => {
    validInput(value, callback, regex.number0_100_4)
  },
  validPoint5: (rule, value, callback) => {
    validInput(value, callback, regex.floatNumber7)
  },
  validPointNoZero: (rule, value, callback) => {
    if (!value) {
      callback()
    }
    if (+value > 0) {
      validInput(value, callback, regex.floatNumber)
    } else {
      return callback(new Error('请输入大于0的数字'))
    }
  },
  validMobile: (rule, value, callback) => {
    validInput(value, callback, regex.mobile, true)
  },
  validEmail: (rule, value, callback) => {
    validInput(value, callback, regex.email)
  },
  validPhone: (rule, value, callback) => {
    validInput(value, callback, regex.phone)
  },
  validTelphone: (rule, value, callback) => {
    validInput(value, callback, regex.phoneAndMobile)
  },
  validNumber: (rule, value, callback) => {
    validInput(value, callback, regex.number)
  },
  validInput100: (rule, value, callback) => {
    validInput(value, callback, regex.input100)
  },
  validInputSpace100: (rule, value, callback) => {
    validInput(value, callback, regex.inputspace100)
  },
  validInputlimitEight: (rule, value, callback) => {
    validInput(value, callback, regex.floatNumber6)
  },
  validIdCard: (rule, value, callback) => {
    let message = (value && !`${value}`.includes('*') && checkIdCard(value.toUpperCase())) || ''
    if (message === '' || message === '验证通过') {
      callback()
    } else {
      return callback(new Error(message))
    }
  },
  validAccount: (rule, value, callback) => {
    validInput(value, callback, regex.accountNum)
  },
  validCorpNumber: (rule, value, callback) => {
    validInput(value, callback, regex.corpNumber)
  },
  validCorpNumber50: (rule, value, callback) => {
    validInput(value, callback, regex.corpNumber50)
  },
  validXingYeNumber: (rule, value, callback) => {
    validInput(value, callback, regex.xingyeAccount)
  },
  validPassword: (rule, value, callback) => {
    validInput(value, callback, regex.password)
  },
  validPassword0: (rule, value, callback) => {
    validInput(value, callback, regex.password0)
  },
  validPassword1: (rule, value, callback) => {
    validInput(value, callback, regex.password1)
  },
  validPassword2: (rule, value, callback) => {
    validInput(value, callback, regex.password2)
  },
  validInputNoSymbols: (rule, value, callback) => {
    validInputSymbols(value, callback, regex.speicalSymbols)
  },
  validDocumentName: (rule, value, callback) => {
    validInput(value, callback, regex.documentName)
  },
  validDocumentType: (rule, value, callback) => {
    validInput(value, callback, regex.documentType)
  },
  validDocumentRemark: (rule, value, callback) => {
    validInput(value, callback, regex.documentRemark)
  },
  validPositionName: (rule, value, callback) => {
    validInput(value, callback, regex.positionName)
  },
  validInputByReg: (rule, value, callback) => {
    validInput(value, callback, rule.reg)
  }
}

export const fieldValid = {
  account: (value) => {
    return (value && regex.accountNum.test(value)) || false
  }
}

export const validateForm = (form, data) => {
  return new Promise((resolve, reject) => {
    form.validate((valid, error) => {
      if (valid) { resolve(data) } else {
        reject(error)
      }
    })
  })
}

export default formValid



// WEBPACK FOOTER //
// ./src/utils/form.js